var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"element-studio-icon-options"},[_c('div',{staticClass:"mb-3"},[_c('h3',{staticClass:"mb-2"},[_vm._v("Icon Options")]),_c('v-combobox',{attrs:{"clearable":"","multiple":"","value":_vm.internalValue.suggestions,"label":"Suggestions"},on:{"input":_vm.updateSuggestions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }